var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-style-container",class:{ 'edit-style-container--active': _vm.isActive }},[_c('div',{staticClass:"edited edit-style-container__content"},[_vm._v(" "+_vm._s(_vm.$t('common.edited'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }